var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.320312,
    width: 36,
    height: 36,
    rx: 8,
    fill: "url(#paint0_radial_1026_17807)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1026_17807)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5041 9.59032C11.8966 9.82657 11.3828 10.1416 10.8691 10.6553C10.3553 11.1653 10.0403 11.6828 9.80406 12.2866C9.57531 12.8716 9.42156 13.5428 9.37656 14.5253C9.33156 15.5078 9.32031 15.8228 9.32031 18.3278C9.32031 20.8328 9.33156 21.1478 9.37656 22.1303C9.42156 23.1128 9.57906 23.7841 9.80406 24.3691C10.0403 24.9766 10.3553 25.4903 10.8691 26.0041C11.3828 26.5178 11.8966 26.8328 12.5041 27.0691C13.0891 27.2978 13.7603 27.4516 14.7428 27.4966C15.7253 27.5416 16.0403 27.5528 18.5453 27.5528C21.0503 27.5528 21.3653 27.5416 22.3478 27.4966C23.3303 27.4516 24.0016 27.2941 24.5866 27.0691C25.1941 26.8328 25.7078 26.5178 26.2216 26.0041C26.7353 25.4903 27.0503 24.9766 27.2866 24.3691C27.5153 23.7841 27.6691 23.1128 27.7141 22.1303C27.7591 21.1478 27.7703 20.8328 27.7703 18.3278C27.7703 15.8228 27.7591 15.5078 27.7141 14.5253C27.6691 13.5428 27.5116 12.8716 27.2866 12.2866C27.0503 11.6828 26.7353 11.1653 26.2253 10.6553C25.7116 10.1416 25.1978 9.82657 24.5903 9.59032C24.0053 9.36157 23.3341 9.20782 22.3516 9.16282C21.3691 9.11782 21.0541 9.10657 18.5491 9.10657C16.0441 9.10657 15.7291 9.11782 14.7466 9.16282C13.7603 9.20407 13.0891 9.36157 12.5041 9.59032ZM22.2728 10.8203C23.1728 10.8616 23.6603 11.0116 23.9866 11.1391C24.4178 11.3078 24.7253 11.5066 25.0478 11.8291C25.3703 12.1516 25.5691 12.4591 25.7378 12.8903C25.8653 13.2166 26.0153 13.7041 26.0566 14.6041C26.1016 15.5753 26.1091 15.8678 26.1091 18.3316C26.1091 20.7953 26.0978 21.0878 26.0566 22.0591C26.0153 22.9591 25.8653 23.4466 25.7378 23.7728C25.5691 24.2041 25.3703 24.5116 25.0478 24.8341C24.7253 25.1566 24.4178 25.3553 23.9866 25.5241C23.6603 25.6516 23.1728 25.8016 22.2728 25.8428C21.3016 25.8878 21.0091 25.8953 18.5453 25.8953C16.0816 25.8953 15.7891 25.8841 14.8178 25.8428C13.9178 25.8016 13.4303 25.6516 13.1041 25.5241C12.6728 25.3553 12.3653 25.1566 12.0428 24.8341C11.7203 24.5116 11.5216 24.2041 11.3528 23.7728C11.2253 23.4466 11.0753 22.9591 11.0341 22.0591C10.9891 21.0878 10.9816 20.7953 10.9816 18.3316C10.9816 15.8678 10.9928 15.5753 11.0341 14.6041C11.0753 13.7041 11.2253 13.2166 11.3528 12.8903C11.5216 12.4591 11.7203 12.1516 12.0428 11.8291C12.3653 11.5066 12.6728 11.3078 13.1041 11.1391C13.4303 11.0116 13.9178 10.8616 14.8178 10.8203C15.7891 10.7753 16.0816 10.7678 18.5453 10.7678C21.0091 10.7678 21.3016 10.7753 22.2728 10.8203Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8086 18.3316C13.8086 20.9491 15.9311 23.0678 18.5448 23.0678C21.1586 23.0678 23.2811 20.9453 23.2811 18.3316C23.2811 15.7178 21.1623 13.5953 18.5448 13.5953C15.9273 13.5953 13.8086 15.7141 13.8086 18.3316ZM21.6198 18.3316C21.6198 20.0303 20.2436 21.4066 18.5448 21.4066C16.8461 21.4066 15.4698 20.0303 15.4698 18.3316C15.4698 16.6328 16.8461 15.2566 18.5448 15.2566C20.2436 15.2566 21.6198 16.6328 21.6198 18.3316Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4725 14.5141C24.0834 14.5141 24.5787 14.0188 24.5787 13.4078C24.5787 12.7969 24.0834 12.3016 23.4725 12.3016C22.8615 12.3016 22.3662 12.7969 22.3662 13.4078C22.3662 14.0188 22.8615 14.5141 23.4725 14.5141Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1026_17807",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1.15292 33.0192) rotate(-3.00009) scale(52.0574 44.2483)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2634,
    stopColor: "#F47133"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6091,
    stopColor: "#BC3081"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C63D2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1026_17807"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.2,
    height: 19.2,
    fill: "white",
    transform: "translate(8.90039 8.72031)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.62642cfa.svg";
export { ForwardRef as ReactComponent };